import React, { Fragment, useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Flex, Grid, Icon, Select, Stack } from "@storyofams/react-ui";
import { createClient } from "@supabase/supabase-js";
import axios from "axios";
import FormData from "form-data";
import { useForm } from "react-hook-form";
import { defineMessages, useIntl } from "react-intl";

import { useQuery } from "react-query";
import * as Yup from "yup";
import { showToast } from "~lib";
import { Button, Input, Text } from "../../../../components";
import { Cross, Star } from "../../../../components/common/Icons";
import { useShopify } from "../../../../context";
import { FileInput } from "./FileInput";

const messages = defineMessages({
  writeReview: "Schrijf een review",
  buyer: "Verified buyer",
  questions: "vragen",
  sectionTitle: "Schrijf een review",
  name: "Naam*",
  namePlaceholder: "Vul hier uw naam in",
  email: "E-mailadres*",
  emailPlaceholder: "Uw e-mailadres",
  rate: "Beoordeling",
  title: "Titel van de beoordeling",
  titlePlaceholder: "Een mooie titel",
  bodyPlaceholder: "Schrijf hier uw beoordeling...",
  photoPlaceholder: "voeg hier je foto’s of video’s toe",
  submit: "Plaats review",
});
export const usages = [
  { label: "DIY", value: "DIY" },
  { label: "Kant en klaar", value: "Kant en klaar" },
  { label: "Beide", value: "Beide" },
];
export const ReviewForm = ({
  propertys,
  productId,
  closeModal,
  productTitle,
}) => {
  const intl = useIntl();
  const [currentRate, setRate] = useState(5);
  const [files, setFiles] = useState([]);
  const [age, setAge] = useState<any>();
  const [usage, setUsage] = useState<any>();
  const [skinType, setSkinType] = useState<any>();
  const [usageError, setUsageError] = useState(false);
  const [purposeState, setPurpose] = useState<any>();
  const [bodyParts, setBodyParts] = useState<any>();
  const { customer } = useShopify();
  const schema = Yup.object().shape({
    email: Yup.string().email().required().trim(),
    name: Yup.string()
      .required()
      .trim()
      .min(2)
      .matches(/[A-Za-z]/, "Verkeerde naam"),
    body: Yup.string().required("Message is a required field").trim(),
    title: Yup.string().required("Title is a required field").trim(),
  });
  const supabase = createClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL,
    process.env.NEXT_PUBLIC_SUPABASE_KEY
  );
  const { data: customerData } = useQuery(
    ["customerData", customer, productId],
    async () => {
      const { data } = await supabase
        .from("customer_profiles")
        .select("*")
        .eq("email", customer?.emailAddress?.emailAddress);
      return data[0];
    },
    { refetchOnWindowFocus: false, enabled: !!customer }
  );
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    setValue,
  } = useForm<any>({
    resolver: yupResolver(schema),
  });
  const setCustomerData = () => {
    if (customerData.skinType) {
      setSkinType(
        customerData.skinType
          .split(",")
          .map((item) => ({ label: item, value: item }))
      );
    }
    if (customerData.age) {
      setAge(propertys.ages.find(({ value }) => value === customerData.age));
    }
    if (customerData.skinCondition) {
      setPurpose(
        customerData.skinCondition
          .split(",")
          .map((item) => ({ label: item, value: item }))
      );
    }
    if (customerData.usage) {
      setUsage(usages.find(({ value }) => value === customerData.usage));
    }
  };
  useEffect(() => {
    if (customer) {
      setValue("name", customer.firstName);
      setValue("email", customer?.emailAddress?.emailAddress);
      if (customerData) setCustomerData();
    }
  }, [customer, customerData]);
  return (
    <Box
      as="form"
      width="100%"
      id="form"
      borderRadius="md"
      bg="#FCF9F7"
      py={["20px", "33px"]}
      px={["17px", "100px"]}
      border="1px solid grey200"
      css={{ "scroll-margin-top": "30px" }}
      position={"relative"}
      mb={2}
      onSubmit={handleSubmit(async (input) => {
        if (!usage) {
          setUsageError(true);
          return;
        }
        let fileUrls = null;
        try {
          if (files && files.length) {
            const { data: staged } = await axios.post(
              "/api/shopify/media/getStagedData",
              files.map(({ name, type, size }) => ({
                filename: name,
                mimeType: type,
                fileSize: String(size),
                resource: type.includes("image") ? "IMAGE" : "VIDEO",
                httpMethod: "POST",
              }))
            );
            const uploadedFiles = [];
            staged.stagedUploadsCreate.stagedTargets.forEach(
              ({ parameters, url }, i) => {
                const formData = new FormData();
                parameters.forEach((item) =>
                  formData.append(item.name, item.value)
                );
                formData.append("file", files[i], {
                  filename: files[i].name,
                  contentType: files[i].type,
                });
                uploadedFiles.push(axios.post(url, formData));
              }
            );
            await Promise.all(uploadedFiles);
            const { data: res } = await axios.post(
              "/api/shopify/media/uploadMedia",
              staged.stagedUploadsCreate.stagedTargets.map(
                ({ resourceUrl }, i) => ({
                  alt: "review media",
                  contentType: files[i].type.includes("image")
                    ? "IMAGE"
                    : "VIDEO",
                  originalSource: resourceUrl,
                })
              )
            );
            fileUrls = res.files.map(({ id }) => id);
          }

          const { data } = await supabase
            .from("product_reviews")
            .select("id")
            .order("id", { ascending: false })
            .limit(1);
          const id = data[0].id + 1;
          if (customerData) {
            await supabase.from("customer_profiles").upsert({
              id: customerData.id,
              age: age?.value || null,
              usage: usage?.value || null,
              skinType:
                skinType && skinType.map(({ value }) => value).join(","),
              skinCondition:
                purposeState &&
                purposeState.map(({ value }) => value).join(","),
            });
          } else {
            const {
              data: [customer],
            } = await supabase
              .from("customer_profiles")
              .select("*")
              .eq("email", input.email);
            if (!customer) {
              const { data } = await supabase
                .from("customer_profiles")
                .select("id")
                .order("id", { ascending: false })
                .limit(1);
              const id = data[0].id + 1;
              await supabase.from("customer_profiles").upsert({
                id,
                age: age?.value || null,
                email: input.email,
                usage: usage?.value || null,
                skinType:
                  skinType && skinType.map(({ value }) => value).join(","),
                skinCondition:
                  purposeState &&
                  purposeState.map(({ value }) => value).join(","),
              });
            } else {
              await supabase.from("customer_profiles").upsert({
                id: customer.id,
                age: age?.value || null,
                usage: usage?.value || null,
                skinType:
                  skinType && skinType.map(({ value }) => value).join(","),
                skinCondition:
                  purposeState &&
                  purposeState.map(({ value }) => value).join(","),
              });
            }
          }
          const { error } = await supabase.from("product_reviews").insert({
            id,
            published: false,
            productId,
            body: input.body,
            email: input.email,
            author: input.name,
            title: input.title,
            rating: currentRate,
            bodyParts:
              bodyParts && bodyParts.map(({ value }) => value).join(","),
            gql_ids: fileUrls,
            productTitle,
          });
          showToast("Beoordeling gemaakt", "success");
          closeModal();
          reset();
          setFiles([]);
          if (error) throw new Error();
        } catch (e) {
          console.log(e);
          showToast("Error", "error");
          reset();
          setFiles([]);
        }
      })}
    >
      <Flex
        justifyContent={"space-between"}
        alignItems={["start", "center"]}
        mb={2}
        flexDirection={["column", "row"]}
      >
        <Text
          fontFamily={"DINPro"}
          fontWeight={700}
          fontSize={"28px"}
          mb={["15px", 0]}
        >
          {intl.formatMessage(messages.writeReview)}
        </Text>
        {!customer && (
          <Flex alignItems={"center"}>
            <Text mr={"9px"}>Heb je een account?</Text>
            <Button
              as="a"
              href="/api/auth/login"
              width={100}
              py={"0 !important"}
              minHeight={44}
              lineHeight={1}
              px={"0 !important"}
              variant="secondary"
            >
              Log in
            </Button>
          </Flex>
        )}
      </Flex>
      <Grid rowSize={[1, 2]} columnGap={2} mb={3}>
        <Stack space={"20px"} flexDirection="column" mb={2}>
          <Box width="100%">
            <Text variant="label" mb={"20px"}>
              Beoordeling*
            </Text>

            <Stack width="100%" space={0.5} mb="20px">
              {[1, 2, 3, 4, 5].map((rate) => (
                <Fragment key={`rate-input=${rate}`}>
                  <Text
                    as={"label" as any}
                    variant="label"
                    htmlFor={`rate-${rate}`}
                    css={{ "&:hover": { cursor: "pointer" } }}
                    // @ts-ignore
                    ariaLabel={`Rate ${rate} stars`}
                  >
                    <Box
                      onClick={() => setRate(rate)}
                      as="input"
                      type="radio"
                      id={`rate-${rate}`}
                      value={rate}
                      css={{ appearance: "none !important" }}
                      position="absolute"
                    />

                    <Icon
                      icon={Star}
                      fontSize={2}
                      color={currentRate >= rate ? "oldPink" : "grey200"}
                    />
                  </Text>
                </Fragment>
              ))}
            </Stack>
          </Box>
          <Input
            label={"Naam*"}
            placeholder={intl.formatMessage(messages.namePlaceholder)}
            error={errors?.name?.message && String(errors?.name?.message)}
            {...register("name")}
          />

          <Input
            type="email"
            label={"E-mailadres*"}
            placeholder={intl.formatMessage(messages.emailPlaceholder)}
            error={errors?.email?.message && String(errors?.email?.message)}
            {...register("email")}
          />

          <Input
            label={"Titel van beoordeling*"}
            error={errors?.title?.message && String(errors?.title?.message)}
            placeholder={intl.formatMessage(messages.titlePlaceholder)}
            {...register("title")}
          />
          <Input
            height={"146px"}
            as="textarea"
            rows={4}
            label="Je beoordeling*"
            placeholder={intl.formatMessage(messages.bodyPlaceholder)}
            error={errors?.body?.message && String(errors?.body?.message)}
            {...register("body")}
            mb={5}
          />
        </Stack>
        <Stack space={"20px"} flexDirection="column">
          <Select
            value={usage}
            onChange={(e) => {
              setUsage(e);
              setUsageError(false);
            }}
            options={usages}
            label="Gebruik*"
            error={usageError && "Usage is required"}
            placeholder="Selecteer je gebruik"
            css={`
              border: 1px solid #c1bebd;
              border-radius: 8px;
              & > div {
                min-height: 46px;
                border-radius: 7px !important;
                font-size: 16px;
                transition: border-color 0.18s ease-in-out,
                  background-color 0.18s ease-in-out;
              }
              &:not(:disabled) {
                &:hover,
                &:active,
                &:focus {
                  border-color: black;
                }
              }
              .react-select__option {
                padding: 3px 3px;
                &:hover {
                  background: #f4f3f0;
                }
              }
            `}
          />
          <Select
            value={age}
            options={propertys.ages}
            onChange={(e) => setAge(e)}
            label="Leeftijd"
            placeholder="Selecteer je leeftijdsgroep"
            css={`
              border: 1px solid #c1bebd;
              border-radius: 8px;
              & > div {
                min-height: 46px;
                backgroud: red;
                border-radius: 7px !important;
                font-size: 16px;
                transition: border-color 0.18s ease-in-out,
                  background-color 0.18s ease-in-out;
              }
              &:not(:disabled) {
                &:hover,
                &:active,
                &:focus {
                  border-color: black;
                }
              }
              .react-select__option {
                padding: 3px 3px;
                &:hover {
                  background: #f4f3f0;
                }
              }
            `}
          />
          <Select
            value={skinType}
            onChange={(e) => setSkinType(e)}
            options={propertys.skinTypes}
            label="Huidtype"
            //@ts-ignore
            isMulti={true}
            placeholder="Selecteer je huidtype"
            css={`
              border: 1px solid #c1bebd;
              border-radius: 8px;
              & > div {
                min-height: 46px;
                border-radius: 7px !important;
                font-size: 16px;
                transition: border-color 0.18s ease-in-out,
                  background-color 0.18s ease-in-out;
              }
              &:not(:disabled) {
                &:hover,
                &:active,
                &:focus {
                  border-color: black;
                }
              }
              .react-select__option {
                padding: 3px 3px;
                &:hover {
                  background: #f4f3f0;
                }
              }
              .css-1rhbuit-multiValue {
                border-radius: 4px;
                padding: 3px;
                background: #fcf9f7;
                border: 1px solid #c1bebd;
              }
              .react-select__value-container {
                height: 100%;
              }
            `}
          />
          <Select
            value={purposeState}
            onChange={(e) => setPurpose(e)}
            options={propertys.skinConditions}
            label="Huidaandoening"
            //@ts-ignore
            isMulti={true}
            placeholder="Selecteer je huidaandoening"
            css={`
              border: 1px solid #c1bebd;
              border-radius: 8px;
              & > div {
                min-height: 46px;
                border-radius: 7px !important;
                font-size: 16px;
                transition: border-color 0.18s ease-in-out,
                  background-color 0.18s ease-in-out;
              }
              &:not(:disabled) {
                &:hover,
                &:active,
                &:focus {
                  border-color: black;
                }
              }
              .react-select__option {
                padding: 3px 3px;
                &:hover {
                  background: #f4f3f0;
                }
              }
              .css-1rhbuit-multiValue {
                border-radius: 4px;
                background: #fcf9f7;
                padding: 3px;
                border: 1px solid #c1bebd;
              }
              .react-select__value-container {
                height: 100%;
              }
            `}
          />
          <Select
            value={bodyParts}
            onChange={(e) => setBodyParts(e)}
            options={propertys.bodyParts}
            label="Lichaamsdeel"
            //@ts-ignore
            isMulti={true}
            placeholder="Selecteer je lichaamsdeel"
            css={`
              border: 1px solid #c1bebd;
              border-radius: 8px;
              & > div {
                min-height: 46px;
                border-radius: 7px !important;
                font-size: 16px;
                transition: border-color 0.18s ease-in-out,
                  background-color 0.18s ease-in-out;
              }
              &:not(:disabled) {
                &:hover,
                &:active,
                &:focus {
                  border-color: black;
                }
              }
              .react-select__option {
                padding: 3px 3px;
                &:hover {
                  background: #f4f3f0;
                }
              }
              .react-select__value-container {
                height: 100%;
              }
              .css-1rhbuit-multiValue {
                border-radius: 4px;
                background: #fcf9f7;
                padding: 3px;
                border: 1px solid #c1bebd;
              }
            `}
          />
          <FileInput files={files} onChange={setFiles} />
        </Stack>
      </Grid>
      <Flex justifyContent={["center", "end"]}>
        <Button
          type="submit"
          width={["100%", "auto"]}
          variant="primary"
          isLoading={isSubmitting}
          disabled={isSubmitting}
        >
          Plaats jouw review
        </Button>
      </Flex>
      <Icon
        onClick={closeModal}
        cursor={"pointer"}
        top={2}
        right={2}
        fontSize={"20px"}
        color="black"
        position={"absolute"}
        icon={Cross}
      />
    </Box>
  );
};
